/**
 * @generated SignedSource<<045475e521f727a2273488cdc88bc83b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminContainer_resolvedResource$data = {
  readonly __typename: string;
  readonly chorusId?: number | null;
  readonly chorusUuid?: string | null;
  readonly featuredImage?: {
    readonly image: {
      readonly originalUrl: string;
      readonly wpId: number;
    };
  } | null;
  readonly globalId: string;
  readonly id: string;
  readonly primaryCategory?: {
    readonly id: string;
  };
  readonly wpId: number;
  readonly " $fragmentType": "AdminContainer_resolvedResource";
};
export type AdminContainer_resolvedResource$key = {
  readonly " $data"?: AdminContainer_resolvedResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminContainer_resolvedResource">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wpId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminContainer_resolvedResource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "globalId",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chorusId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chorusUuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FeaturedImageType",
          "kind": "LinkedField",
          "name": "featuredImage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageResourceType",
              "kind": "LinkedField",
              "name": "image",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "originalUrl",
                  "storageKey": null
                },
                (v1/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CategoryResourceType",
              "kind": "LinkedField",
              "name": "primaryCategory",
              "plural": false,
              "selections": [
                (v0/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "FeedContentResourceInterface",
          "abstractKey": "__isFeedContentResourceInterface"
        }
      ],
      "type": "ContentResourceInterface",
      "abstractKey": "__isContentResourceInterface"
    }
  ],
  "type": "ResolvedResourceInterface",
  "abstractKey": "__isResolvedResourceInterface"
};
})();

(node as any).hash = "c75cbdd71903d1c8cefd82e768577e49";

export default node;
